"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSurveyDynamicFormQuestionEntity = exports.isSurveyTextQuestionEntity = exports.isSurveyMultipleChoiceQuestionEntity = exports.isSurveySingleChoiceQuestionEntity = exports.isSurveyRatingChoiceQuestionEntity = exports.isSurveyBooleanChoiceQuestionEntity = void 0;
var isSurveyBooleanChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "survey-boolean-choice-question";
};
exports.isSurveyBooleanChoiceQuestionEntity = isSurveyBooleanChoiceQuestionEntity;
var isSurveyRatingChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "survey-rating-question";
};
exports.isSurveyRatingChoiceQuestionEntity = isSurveyRatingChoiceQuestionEntity;
var isSurveySingleChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "survey-single-choice-question";
};
exports.isSurveySingleChoiceQuestionEntity = isSurveySingleChoiceQuestionEntity;
var isSurveyMultipleChoiceQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "survey-multiple-choice-question";
};
exports.isSurveyMultipleChoiceQuestionEntity = isSurveyMultipleChoiceQuestionEntity;
var isSurveyTextQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "survey-text-question";
};
exports.isSurveyTextQuestionEntity = isSurveyTextQuestionEntity;
var isSurveyDynamicFormQuestionEntity = function (question) {
    return question.__type.split(".").pop() == "survey-dynamic-form-question";
};
exports.isSurveyDynamicFormQuestionEntity = isSurveyDynamicFormQuestionEntity;
